<template>
  <div class="setting">

<el-breadcrumb separator="/">
  <el-breadcrumb-item :to="{ name: 'allDomain' }">{{$t('allDomain.DomainNames')}}</el-breadcrumb-item>
  <el-breadcrumb-item :to="{ name: 'subdomains', params: { id: id } }">{{ subhost }}</el-breadcrumb-item>
  <el-breadcrumb-item>{{this.$t('allDomain.config')}} | {{ host }}</el-breadcrumb-item>
</el-breadcrumb>

    <!--  -->
    <div v-if="domainHost" class="tab-content">
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane lazy :label="$t('allDomain.config')" name="config">
        <SettingsCache name="host" :id="sid" />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('settings.strategy')" name="strategy">
        <SettingsStrategy name="host" :id="sid" />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('allDomain.originSettings')" name="origin">
      <OriginSite :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>
    
    <el-tab-pane lazy :label="$t('allDomain.visitLog')" name="log">
      <visitLog :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>

    <el-tab-pane lazy :label="$t('allDomain.maintain')" name="maintain">
      <maintain :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>

    <!-- <el-tab-pane :label="$t('allDomain.config')" name="six">
      <childDomainConfig :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane> -->

    <el-tab-pane lazy :label="$t('allDomain.applyCert')" name="cert">
      <SubdomainCert :domainHost="domainHost" :serverJson="host_json_server" :cname="cname" />
    </el-tab-pane>

    <!-- <el-tab-pane :label="$t('allDomain.config')" name="first">
      <childDomainConfig :subhost="subhost" :domainHost="rootDomain" type="main" />
    </el-tab-pane> -->
    <!-- <el-tab-pane :label="$t('product.cache')" name="third">
        <CacheSetting />
    </el-tab-pane>
    <el-tab-pane :label="$t('product.strategy')" name="four">
        <CeNueSetting />
    </el-tab-pane> -->
  </el-tabs>
    </div>
  </div>
</template>

<script>
import { apiGetDetail } from "@/service/requestRes";

// import domainSettingItem1 from '@/views/domain/domainSettingItem1.vue';
// import domainSettingItem2 from '@/views/domain/domainSettingItem2.vue';
// import CacheSetting from '@/views/products/CacheSetting.vue';
// import CeNueSetting from '@/views/products/CeNueSetting.vue';
// import childDomainConfig from '@/views/dev/childDomainConfig.vue';
import SettingsCache from '@/views/domain/SettingsCache.vue'
import SettingsStrategy from '@/views/domain/SettingsStrategy.vue'
import OriginSite from '@/views/dev/OriginSite.vue';
import visitLog from '@/views/dev/visitLog.vue';
import maintain from '@/views/dev/maintain.vue';
import SubdomainCert from '@/views/domain/SubdomainCert.vue';


export default {
  components: {
    // domainSettingItem1,
    // domainSettingItem2,
    // CacheSetting,
    // CeNueSetting,
    // childDomainConfig,
    OriginSite,
    visitLog,
    maintain,
    SubdomainCert,
    SettingsCache,
    SettingsStrategy,
  },
  props: {
    rootDomain: String,
  },
  data() {
    return {
      id: this.$route.params.id,
      sid: this.$route.params.sid,
      activeName: 'config',
      detail: null,
      subhost: null,
      host: null,
      domainHost: null,
      host_json_server: '',
      cname: null,
    };
  },
  mounted(){
    this.getDetail();
  },
  computed: {
    items() {
      return [
        {
          label: this.$t('allDomain.DomainNames'),
          click: () => {
            this.$emit('closePage');
          },
        },
        {
          label: this.$t('allDomain.config'),
        },
      ];
    },
  },
  methods: {
    getDetail() {
      apiGetDetail(
          'host', this.sid
      ).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
            this.subhost = data.sub_host;
            this.host = data.host;
            this.domainHost = data.host;
            this.host_json_server = data.host_json_server || '';
            this.cname = data.cname || '';
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    handleClick(tab, event) {
    //   console.log(tab, event);
    },
  },
};
</script>
<style lang="scss" scoped>
  .setting {
    background-color: white;
    padding: 24px;
  }
  .tab-content {
    margin-top: 24px;
    ::v-deep .el-tabs__item.is-active {
       color: #2664FF;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #2664FF;
    }
  }
</style>
